import type { Daemon } from "./types.js";

// Masked rows (Daemon.masked): resolvable by id (DaemonState.byId, isOnline), never listed.
export class MaskedDaemons {
  rows: Daemon[] = $state([]);

  /** The rows to list; the masked ones are kept aside, unchanged when handed back the held list. */
  split(rows: readonly Daemon[], heldList: boolean): Daemon[] {
    if (!heldList) this.rows = rows.filter((d) => d.masked);
    return rows.filter((d) => !d.masked);
  }

  find(daemonId: string): Daemon | undefined {
    return this.rows.find((d) => d.id === daemonId);
  }

  clear(): void {
    this.rows = [];
  }
}
